import { render, staticRenderFns } from "./SessionIndexNew.vue?vue&type=template&id=3bd7252d&"
import script from "./SessionIndexNew.vue?vue&type=script&lang=js&"
export * from "./SessionIndexNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports